import { AREA_TITLE } from "Areas/Settings/routingKeys";
import { routesAndPagesMap } from "Common/routingUtils";
import { themeVariables } from "Components/theme";
import MENU_LOGO from "Content/images/logo/HunterLogoFull.svg";
import classNames from "classnames";
import find from "lodash/find";
import includes from "lodash/includes";
import keyBy from "lodash/keyBy";
import map from "lodash/map";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { SidebarMenuList, SidebarMenuTabs, SidebarMenuToggler, Styled } from "../Common";
import buildSettingsSidebarMenuItems from "./utils/buildSettingsSidebarMenuItems";
import styles from "./settingsSidebarMenu.module.css";
import ButtonHome from "Areas/Sidebar/ButtonHome/ButtonHome";
const SIZES = {
    LOGO_CONTAINER_HEIGHT: 67
};
const collapsedLogoIconContainerStyle = { marginBottom: 54 };
export default function SettingsSidebarMenu(props) {
    const [selected, setSelected] = useState(undefined);
    const selectedSet = useMemo(() => new Set(selected ? [selected] : []), [selected]);
    const sidebarMenuItems = useMemo(() => buildSettingsSidebarMenuItems(), []);
    const sidebarMenuTabs = useMemo(() => {
        let result = [];
        result = result.concat(map(sidebarMenuItems, e => ({ key: e.key, icon: e.icon, hash: e.hash, title: e.title })));
        return keyBy(result, "key");
    }, [sidebarMenuItems]);
    const handleChangeTab = useCallback((itemKey) => {
        const menuItem = find(sidebarMenuItems, ["key", itemKey]);
        if (menuItem === null || menuItem === void 0 ? void 0 : menuItem.hash) {
            window.location.href = menuItem.hash;
        }
    }, [sidebarMenuItems]);
    useEffect(() => {
        var _a;
        if (!sidebarMenuItems.length || !props.routingPage)
            return;
        const keysForSelect = [
            props.routingPage,
            ...map(routesAndPagesMap.getParents(props.routingPage), "key")
        ];
        const newSelected = props.routingPage
            ? (_a = find(sidebarMenuItems, el => includes(keysForSelect, el.key))) === null || _a === void 0 ? void 0 : _a.key
            : undefined;
        setSelected(newSelected);
    }, [sidebarMenuItems, props.routingPage]);
    const logoImg = useMemo(() => React.createElement("img", { draggable: "false", alt: props.productName, src: MENU_LOGO }), [props.productName]);
    const logoPanel = useMemo(() => (React.createElement(Styled.LogoContainer, { sidebarWidth: props.width || 0 },
        React.createElement("div", { className: styles["logo-container"] },
            props.defaultHash ? React.createElement(ButtonHome, { defaultHash: props.defaultHash }) : logoImg,
            React.createElement("div", { className: styles.title }, AREA_TITLE)))), [logoImg, props.defaultHash, props.width]);
    const containerStyle = useMemo(() => ({
        width: props.width ? props.width : "auto",
        backgroundColor: themeVariables["navbar-bg"],
        gridTemplateRows: `${SIZES.LOGO_CONTAINER_HEIGHT}px 1fr`,
        borderRight: themeVariables["navbar-border-right"]
    }), [props.width]);
    return (React.createElement("div", { style: containerStyle, className: classNames("h-100 d-grid", props.className) },
        props.isExpanded ? (React.createElement(React.Fragment, null,
            logoPanel,
            React.createElement(SidebarMenuList, { sidebarMenuItems: sidebarMenuItems, selectedItems: selectedSet, activeItems: selectedSet }))) : (React.createElement(SidebarMenuTabs, { defaultHash: props.defaultHash, productName: props.productName, expandedMenu: false, tabKey: selected, rotateTab: false, rows: 2, tabs: sidebarMenuTabs, onChangeTab: handleChangeTab, logoIconContainerStyle: collapsedLogoIconContainerStyle })),
        React.createElement(SidebarMenuToggler, { isExpanded: props.isExpanded, onExpandedChanged: props.onExpandedChanged })));
}
